import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23;
import styled, { createGlobalStyle } from 'styled-components';
import { aboveMin, mediaLandscape, mediaMin, tabletRange } from '@spa/shared/theme';
import { TitleModalWrapper } from './TitleModal/styles';
import { Wrapper as ModalWrapper, Box as ModalBox, Content as ModalContent } from '@spa/shared/components/Modal/styles';
import { Action } from '@spa/offer/components/Modals/PhotosModal/ShareAndWishlist/styles';
import { Wrapper as ChipWrapper } from '@spa/shared/components/Unisystem/Chip/styles';
export var ModalGlobalStyle = /*#__PURE__*/createGlobalStyle(["", "{max-height:100%;}.photos-modal{border-radius:0;", "{background:#fafafa;", " .close-icon{display:none;}}", "{min-height:100%;padding-top:0;padding:", ";", " ", "}&.photos-carousel{background:", ";", "{h1,p{color:", ";}}header{background-color:transparent;& > button{color:", ";", " svg{width:15px;height:15px;}&:hover{background:", ";}}}", "{", "}}}"], ModalWrapper, ModalBox, mediaMin.largeBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        padding: 0;\n      "]))), ModalContent, function (_ref) {
  var isGallery = _ref.isGallery,
    theme = _ref.theme;
  return isGallery ? '0' : "0 ".concat(theme.space(33), " ").concat(theme.space(10));
}, tabletRange.ipad()(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        padding: ", ";\n      "])), function (_ref2) {
  var isGallery = _ref2.isGallery,
    theme = _ref2.theme;
  return !isGallery && theme.space(4);
}), mediaMin.mediumBreakpoint(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        padding: ", ";\n      "])), function (_ref3) {
  var isGallery = _ref3.isGallery,
    theme = _ref3.theme;
  return isGallery ? '0' : "".concat(theme.space(4), " ").concat(theme.space(4), " ").concat(theme.space(8));
}), function (props) {
  return props.theme.photosModal.carouselSection.background;
}, TitleModalWrapper, function (props) {
  return props.theme.photosModal.carouselSection.textColor;
}, function (props) {
  return props.theme.photosModal.carouselSection.textColor;
}, mediaMin.largeBreakpoint(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            padding: 0;\n          "]))), function (props) {
  return props.theme.photosModal.carouselSection.button.hover;
}, ModalContent, mediaMin.largeBreakpoint(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          padding-inline: ", ";\n        "])), function (props) {
  return props.theme.space(5);
}));
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1imzkxw-0"
})(["display:flex;flex-direction:column;", ";overflow-y:auto;height:100%;"], function (props) {
  return props.theme.gap(4, 'column');
});
export var HeaderModal = /*#__PURE__*/styled.header.withConfig({
  componentId: "sc-1imzkxw-1"
})(["display:flex;justify-content:space-between;flex-wrap:wrap;margin-right:0;position:sticky;top:0;background-color:", ";z-index:1;padding-top:", ";", " ", " ", " & > div:nth-of-type(2){width:100%;}button{svg{display:inline-block;}}", " ", "{svg{path{stroke:", ";}}}", ""], function (props) {
  return props.theme.photosModal.stickyHeader.background;
}, function (props) {
  return props.theme.space(10);
}, mediaMin.largeBreakpoint(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), function (props) {
  return props.theme.space(1);
}), function (_ref4) {
  var isGallery = _ref4.isGallery;
  return isGallery && aboveMin.largeBreakpoint(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      padding: ", " ", " ", ";\n  "])), function (props) {
    return props.theme.space(10);
  }, function (props) {
    return props.theme.space(33);
  }, function (props) {
    return props.theme.space(15);
  });
}, function (_ref5) {
  var isGallery = _ref5.isGallery;
  return isGallery && mediaMin.largeBreakpoint(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      padding: ", ";\n  "])), function (props) {
    return props.theme.space(5);
  });
}, tabletRange.ipad()(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    align-items: flex-start;\n    width: 100%;\n    display: block;\n  "]))), Action, function (props) {
  return props.theme.photosModal.actionSvgStroke;
}, mediaMin.mediumBreakpoint(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n    min-height: min-content;\n\n    ", "\n  "])), function (props) {
  return props.theme.space(8);
}, mediaLandscape(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      padding-bottom: ", ";\n      padding-top: ", ";\n    "])), function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(1);
})));
export var TitleWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1imzkxw-2"
})(["transition:max-height 0.3s ease-in-out;max-height:", ";overflow:hidden;"], function (_ref6) {
  var show = _ref6.show;
  return show ? '100px' : '0';
});
export var Heading = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1imzkxw-3"
})(["display:flex;align-items:center;justify-content:space-between;flex-basis:100%;margin-top:", ";", ""], function (props) {
  return props.theme.space(3);
}, mediaMin.mediumBreakpoint(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    ", "\n  "])), mediaLandscape(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      margin-top: 0;\n    "])))));
export var Content = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1imzkxw-4"
})(["width:100%;height:100%;"]);
export var ChipsWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1imzkxw-5"
})(["display:flex;", ";margin-top:", ";", ""], function (_ref7) {
  var theme = _ref7.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.space(4);
}, mediaMin.mediumBreakpoint(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    width: 100%;\n    margin-top: 0;\n    overflow: hidden;\n  "]))));
export var Chips = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1imzkxw-6"
})(["display:flex;align-items:center;flex-wrap:wrap;", ";", "{height:34px;}svg{width:24px;}", " ", " .extra-chips{border:1px solid ", ";min-width:auto;svg{width:24px;height:24px;path{fill:", ";}}", " &:nth-last-child(2){svg{width:20px;height:20px;}}}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.gap(2);
}, ChipWrapper, mediaMin.mediumBreakpoint(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    flex-wrap: nowrap;\n    flex-basis: 100%;\n    padding-top: ", ";\n    overflow-x: scroll;\n    ", ";\n\n    & > button {\n      flex-shrink: 0;\n\n      &:hover {\n        background: ", ";\n        color: ", ";\n        border: 1px solid ", ";\n      }\n    }\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  "])), function (props) {
  return props.theme.space(5);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.gap(1);
}, function (props) {
  return props.theme.colors.uniBlue;
}, function (props) {
  return props.theme.colors.lightest;
}, function (props) {
  return props.theme.colors.uniBlue;
}), mediaMin.largeBreakpoint(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    ", "\n  "])), mediaLandscape(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      padding-top: ", ";\n    "])), function (props) {
  return props.theme.space(2);
})), function (props) {
  return props.theme.colors.shadyGray;
}, function (props) {
  return props.theme.colors.blueDianne;
}, mediaMin.mediumBreakpoint(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      height: 36px;\n\n      span {\n        font-size: ", ";\n        line-height: ", ";\n      }\n    "])), function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}));
export var ChipsCarousel = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1imzkxw-7"
})(["display:flex;", ";align-items:center;button{height:40px;min-width:100px;color:", ";border:1px solid ", ";svg{width:24px;height:24px;path{fill:", ";}}}", " ", ""], function (_ref10) {
  var theme = _ref10.theme;
  return theme.gap(3);
}, function (props) {
  return props.theme.photosModal.carouselSection.chips.textColor;
}, function (props) {
  return props.theme.photosModal.carouselSection.chips.borderColor;
}, function (props) {
  return props.theme.photosModal.carouselSection.chips.textColor;
}, tabletRange.ipad()(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    justify-content: flex-end;\n    align-items: center;\n  "]))), mediaMin.mediumBreakpoint(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    margin-left: auto;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: ", ";\n    width: 100%;\n    ", ";\n\n    ", "\n\n    button {\n      &:first-of-type {\n        svg {\n          width: 20px;\n          height: 20px;\n        }\n      }\n    }\n  "])), function (props) {
  return props.theme.space(2);
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.gap(2);
}, mediaLandscape(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n      margin-top: 0;\n    "])))));
export var ChipsFloorPlan = /*#__PURE__*/styled(ChipsCarousel).withConfig({
  componentId: "sc-1imzkxw-8"
})(["button{&:last-of-type{svg{path{fill:none;}}}}", ""], mediaMin.mediumBreakpoint(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    margin-left: auto;\n  "]))));
export var ChipsVideo = /*#__PURE__*/styled(ChipsCarousel).withConfig({
  componentId: "sc-1imzkxw-9"
})(["button{&:first-of-type{svg{width:20px;height:20px;}}&:last-of-type{svg{path{fill:none;}}}}", ""], mediaMin.mediumBreakpoint(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    margin-left: auto;\n  "]))));